import React from "react";

import { Link } from "react-router-dom";

import { Tag } from "antd";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../../core/utils/i18n-js";
import { AmountText } from "../../../../../core/components/widget/amountInline";

import {
    LAYOUT_FINANCE_INVOICE_CLIENT_SHOW,
    LAYOUT_FINANCE_INVOICE_CLIENT_SHOW_PURCHASE_ORDER,
} from "../../../navigation";

import { basicDeleteActionField } from "../../../../../components/table/fields/common";

import { configureField } from "../../../../../core/utils/list";

import { Button, Popconfirm } from "antd";

const confirmationMessage = "Are you sure?";

const INVOICE_TYPE_PURCHASE_ORDER = "PURCHASE ORDER";

export const basicColumns = (props) => {
    const { isAdmin, loading, filters, resize, hidden } = props;

    if (loading) {
        return [];
    }
    return [
        {
            title: "ID #",
            dataIndex: "display_id",
            ...configureField("i.id", filters, resize, hidden, true, false, false, 200),
            fixed: "left",
            render: (id, record) => (
                <Link
                    to={
                        record.type === INVOICE_TYPE_PURCHASE_ORDER
                            ? LAYOUT_FINANCE_INVOICE_CLIENT_SHOW_PURCHASE_ORDER(record.id)
                            : LAYOUT_FINANCE_INVOICE_CLIENT_SHOW(record.id)
                    }
                >
                    {id}
                </Link>
            ),
        },

        {
            title: "Name",
            dataIndex: "number",
            ...configureField("i.number", filters, resize, hidden, true, false, false, 200),
        },
        {
            title: "Client",
            dataIndex: "client_name",
            ...configureField("c.name", filters, resize, hidden, true, false, false, 200),
        },
        {
            title: "Date",
            dataIndex: "date",
            ...configureField("i.date", filters, resize, hidden, true, false, false, 200),
            render: (date) => {
                if (date) return <>{Moment(date).format(DATE_FORMAT)}</>;
            },
        },
        {
            title: "Notes",
            dataIndex: "notes",
            ellipsis: true,
            ...configureField("i.notes", filters, resize, hidden, true, false, true, 200),
        },
        {
            title: "Amount",
            dataIndex: "amount_value",
            ...configureField("i.amountValue", filters, resize, hidden, true, false, true, 200),
            render: (amountValue, record) => {
                return <AmountText value={amountValue} type={record.amount_type} />;
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text) => <Tag color="green">{text}</Tag>,
            ...configureField("i.status", filters, resize, hidden, true, true, true, 200),
            ilters: [
                { text: "In Review", value: "In Review" },
                { text: "Accepted", value: "Accepted" },
                { text: "Valid", value: "Valid" },
                { text: "Paid", value: "Paid" },
            ],
        },
        {
            ...basicDeleteActionField({ remove: isAdmin ? props.remove : null, loading: props.actionLoading }),
            visible: true,
        },
    ];
};
